import React, { Component } from 'react'
import { observer } from 'mobx-react';
import MyFamily from './MyFamily';
import FirstGroupOnboarding from './FirstGroupOnboarding';

@observer(["UserStore", "FamilyStore"])
class Groups extends Component {
    
    render() {
        return (
            <div>
                {this.props.UserStore.user.groups.length === 0 ?
                    <FirstGroupOnboarding /> :
                    <MyFamily groupId={this.props.FamilyStore.activeGroupId} />
                }
            </div>
        )
    }
}
export default Groups;